
export default () => ({
    gallery: [],
})